export const ENVIRONMENT = import.meta.env.VITE_CALIZA_CUSTOMER_DASHBOARD_ENVIRONMENT;
export const KEYCLOAK_UNIVERSAL_FORM_ID = 'keycloak-form';
export const HIGH_PRECISION_DECIMAL_PLACES = 7;
export const IS_PRODUCTION_ENVIRONMENT = ENVIRONMENT === 'production';
export const IS_DEVELOPMENT_ENVIRONMENT = ENVIRONMENT === 'develop';
export const IS_PREVIEW_PRODUCTION_ENVIRONMENT = ENVIRONMENT === 'preview-production';
export const IS_LOCAL_ENVIRONMENT = ENVIRONMENT === 'local';
export const IS_PREVIEW_DEVELOPMENT_ENVIRONMENT = ENVIRONMENT === 'preview-develop';
export const SHOULD_MOCK_DEPOSITS =
  IS_LOCAL_ENVIRONMENT || IS_PREVIEW_DEVELOPMENT_ENVIRONMENT || IS_DEVELOPMENT_ENVIRONMENT;
